import { Text, View, StyleSheet } from '@react-pdf/renderer'

// Create styles
const styles = StyleSheet.create({
  header: {
    backgroundColor: '#00B5A3',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 100,
  },
  headerText: {
    fontFamily: 'Wix Madefor Text',
    textTransform: 'uppercase',
    fontSize: 12,
    color: '#FFFFFF',
  },
})

// Create Document Component
export default function Header({ name, style }: { name: string; style?: any }) {
  const time = new Date()
  return (
    <View style={[styles.header, style]} fixed>
      <Text style={[styles.headerText, { maxWidth: '40%' }]}>{name}</Text>
      <Text style={styles.headerText}>
        REPORTED{' '}
        {time.toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          timeZoneName: 'short',
        })}
      </Text>
    </View>
  )
}
